import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { AppConfigService } from 'src/app/services/app-config.service';
import { handleError } from 'src/app/shared/functions/error-handler';
import { IAppConfig } from 'src/app/shared/interfaces/app-config';
import { AgencyList, VwAgency } from '../../dashboard/interface/agency-list';
import { FilterParam } from '../../dashboard/interface/agency-filter';
import { WaitlistRequest } from '../../dashboard/models/waitlist-request';
import { VwMdeWaitlist } from '../interfaces/mde-waitlist';
import { VwCompleteWorklist } from '../interfaces/complete-worklist';
import { AgencyRequest } from '../interfaces/add-to-worklist';
import { SearchGlobalWorklistRequest } from '../interfaces/search-global-worklist';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  config: IAppConfig;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  public getGobalWorklist(): Observable<VwCompleteWorklist[]> {
    return this.http
      .get<VwCompleteWorklist[]>(`${this.config.apiUrl}/MDE/Worklist`)
      .pipe(catchError(handleError));
  }

  public getMdeWaitlist(agencySk: string): Observable<VwMdeWaitlist[]> {
    return this.http
      .get<VwMdeWaitlist[]>(`${this.config.apiUrl}/MDE/Waitlist/` + agencySk)
      .pipe(catchError(handleError));
  }

  // TODO: This method should return `AgencyList[]` instead of `any`, but currently getting errors and will fix at a later point in time.
  public getMdeAgency(): Observable<any> {
    return this.http
      .get<AgencyList[]>(`${this.config.apiUrl}/MDE/MDEAgencies`)
      .pipe(catchError(handleError));
  }

  public getMDEAgencyList(filterParam: FilterParam): Observable<VwAgency[]> {
    return this.http
      .post<VwAgency[]>(
        `${this.config.apiUrl}/MDE/GetMDEAgencyList`,
        filterParam
      )
      .pipe(catchError(handleError));
  }

  // TODO: The `request` variable should have a data type annotation of `AgencyList` but currently getting errors and will be fixed at a later point in time.
  public saveMdeAgency(request: any): Observable<boolean> {
    return this.http
      .post<boolean>(`${this.config.apiUrl}/MDE/Agency`, request)
      .pipe(catchError(handleError));
  }

  public getAgencyDetails(studentSk: string): Observable<VwAgency[]> {
    return this.http
      .get<VwAgency[]>(
        `${this.config.apiUrl}/MDE/GetMDEListByStudentSk/` + studentSk
      )
      .pipe(catchError(handleError));
  }

  public getMdeAgencyByAgencySk(agencySk: string): Observable<AgencyList> {
    return this.http
      .get<AgencyList>(`${this.config.apiUrl}/MDE/MDEAgency/${agencySk}`)
      .pipe(catchError(handleError));
  }

  public addToWorkList(request: AgencyRequest[]): Observable<boolean> {
    return this.http
      .post<boolean>(`${this.config.apiUrl}/MDE/AddToWorklist`, request)
      .pipe(catchError(handleError));
  }

  public addToWaitlist(request: AgencyRequest): Observable<boolean> {
    return this.http
      .post<boolean>(`${this.config.apiUrl}/MDE/AddToWaitlist`, request)
      .pipe(catchError(handleError));
  }

  public removeFromWaitlist(request: AgencyRequest[]): Observable<boolean> {
    return this.http
      .post<boolean>(`${this.config.apiUrl}/MDE/RemoveFromWaitlist`, request)
      .pipe(catchError(handleError));
  }

  public removeFromWorklist(studentSk: string): Observable<boolean> {
    return this.http
      .post<boolean>(
        `${this.config.apiUrl}/MDE/RemoveFromWorklist/${studentSk}`,
        null
      )
      .pipe(catchError(handleError));
  }

  public addToMDWaitlist(request: WaitlistRequest): Observable<boolean> {
    return this.http
      .post<boolean>(`${this.config.apiUrl}/MDE/AddToMDEWaitlist`, request)
      .pipe(catchError(handleError));
  }

  public getStudentSearchDetails(
    request: SearchGlobalWorklistRequest
  ): Observable<VwCompleteWorklist[]> {
    return this.http
      .post<VwCompleteWorklist[]>(`${this.config.apiUrl}/MDE/Worklist`, request)
      .pipe(catchError(handleError));
  }

  // TODO: wasn't able to find this endpoint in the backend/swagger document
  public getEvaluatorProvidersByAgency(agencySk: string): Observable<any> {
    return this.http
      .get(
        `${this.config.apiUrl}/AgencyManagement/EvaluatorProvidersByAgency/${agencySk}`
      )
      .pipe(catchError(handleError));
  }

  public getMDEAgencyListByAgencySk(agencySk: string): Observable<VwAgency[]> {
    return this.http
      .get<VwAgency[]>(`${this.config.apiUrl}/MDE/GetMDEAgencyList/${agencySk}`)
      .pipe(catchError(handleError));
  }
}
